import { PageConfig, PageConfigContent } from './types';

/** Matches the app's own IntlProvider fallback in `pagesRouterMessages.ts`. */
const FALLBACK_LOCALE = 'en';

/**
 * Per-key merge, not per-block: a `de` block missing `subheader` falls back to the default
 * locale's `subheader` while still using every other `de` field it has. An empty *string* is
 * treated as "not provided" (a saved-but-blank field means "no translation yet," not "translate
 * to nothing"). An empty *array* has no such ambiguity, so it's a real override — an admin who
 * clears `descriptions` for one locale gets zero bullets there, not the default locale's list.
 */
export function resolveLocaleContent(pageConfig: PageConfig, locale: string): PageConfigContent {
	const defaultLocale = pageConfig.default_locale ?? FALLBACK_LOCALE;
	const defaultContent = pageConfig.content?.[defaultLocale] ?? {};
	const localeContent = pageConfig.content?.[locale] ?? {};

	const merged: PageConfigContent = { ...defaultContent };
	(Object.keys(localeContent) as Array<keyof PageConfigContent>).forEach(key => {
		const value = localeContent[key];
		const isProvided = Array.isArray(value) ? true : Boolean(value);
		if (isProvided) {
			// Each branch narrows `value` to the type its own key expects, so this can't mix a
			// `descriptions` array into a string field or vice versa.
			(merged as Record<string, unknown>)[key] = value;
		}
	});
	return merged;
}
